import { TimeUtils } from './timeUtils'

export const CLICK_PREVENT_TIMEOUT_MS = 1500

export const QuestionUtils = {
    getTypeText (type) {
        switch (type) {
        case 'math':
            return 'Matematika'
        case 'popz':
            return 'Popularne znanosti'
        case 'digit':
            return 'Digitalno društvo'
        case 'eng':
            return 'Engleski jezik'
        }
    },

    /**
     * Currently unused
     * @param {*} round
     */
    currentQuestionEndTime (round) {
        let questionIds = Object.keys(round.questions)
        let roundStartTime = round.startTime
        let questionsTime = 0
        for (let i = 0; i < questionIds.length; i++) {
            let key = questionIds[i]
            let question = round.questions[key]
            let questionStartTime = roundStartTime + questionsTime
            let questionEndTime = questionStartTime + question.time
            if (TimeUtils.timeUntilFutureTimestamp(questionStartTime) <= 0 && TimeUtils.timeUntilFutureTimestamp(questionEndTime) > 0) {
                return questionEndTime
            }
        }
        return 0
    },

    questionTimeUntilEnd (round, questionId) {
        let questionIds = Object.keys(round.questions)
        let questionsTime = 0
        for (let i = questionIds.length - 1; i >= 0; i--) {
            let key = questionIds[i]
            if (key !== questionId) {
                let question = round.questions[key]
                questionsTime += question.time
            } else {
                return questionsTime
            }
        }
        return 0
    }
}
